<script setup>
import { useHead } from "@unhead/vue";
import { onUnmounted } from "vue";
import { useNotificationStore } from '@/store';

const ContentUploaderJs = "https://cdn01.boxcdn.net/platform/elements/17.1.0/fr-FR/uploader.js";
const ContentUploaderCss = "https://cdn01.boxcdn.net/platform/elements/17.1.0/fr-FR/uploader.css";

const props = defineProps({
  folderId: String,
  accessToken: String
});

function handleComplete(files) {
  useNotificationStore().emitNotification({
    title: files?.length > 1 
      ? "Documents transmis avec succès"
      : "Document transmis avec succès"
  }, 6000)
}

const BoxCode = useHead({
  script: [
    {
      type: "text/javascript",
      src: ContentUploaderJs,
      onload: () => {
        const accessToken = props.accessToke;
        const contentUploader = new Box.ContentUploader();
        contentUploader.show(props.folderId, props.accessToken , {
          onClose: null,
          buttonLabel: "Nous transmettre des documents",
          container: "#box-file-uploader",
          logoUrl: 'https://ucarecdn.com/b873a4a9-e499-41ed-bce9-322726d13bf1/-/preview/500x500/-/quality/smart_retina/-/format/auto/'
        });

        contentUploader.addListener('complete', handleComplete);

        // const target = document.querySelector(".bcu-upload-state-message");
        // observer.observe(target);
        const div = document.querySelector('.bcu-upload-state-message');
        if (div) div.textContent = 'Glisser déposer des documents ici'; //'Nous transmettre des documents (E-Tickets, Carte d\'identité, etc)';
        
        // const label = document.querySelector(".be-input-link");
        // if (label) label.textContent = "Parcourir votre appareil";
        
        const cancelButton = document.querySelector(".bcu-footer-right button:nth-child(1)");
        if (cancelButton) cancelButton.textContent = "Annuler"

        const uploadButton = document.querySelector(".bcu-footer-right button:nth-child(2)");
        if (uploadButton) uploadButton.textContent = "Envoyer"
      }
    },
  ],
  link: [
    {
      rel: "stylesheet",
      href: ContentUploaderCss,
    },
  ],
});
onUnmounted(() => {
    contentUploader?.removeListener('complete', handleComplete);
    BoxCode.dispose()
})
</script>
<template>
  <div class="border rounded-md">
    <div id="box-file-uploader"></div>
  </div>
</template>
<style>
.upload-empty-state {
  @apply mx-auto;
}
.upload-success-state  {
  @apply mx-auto;
}
</style>